import React from "react";
import FilterModal from "../../components/FilterModal";
import Modal from "../../components/Modal";
import PageActions from "../../components/PageActions";
import PageHeader from "../../components/PageHeader";
import Table from "../../components/Table";
import Pagination from "../../components/Pagination";
import { createTableActions } from "../../utils/tableActions";
import TamanhosForm from "./components/TamanhosForm";
import { TamanhosProvider, useTamanhosPage } from "./context/TamanhosContext";

const TamanhosContent: React.FC = () => {
  const {
    tamanhos,
    lojas,
    isLoading,
    isModalOpen,
    isFilterModalOpen,
    formState,
    filterFields,
    tableData,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    activeFiltersCount,
    isSaving,
    openFilterModal,
    closeFilterModal,
    openCreateModal,
    openEditModal,
    closeModal,
    handleDelete,
    handleSubmit,
    handleFilterFieldChange,
    handleSearch,
    handleClear,
    setFormNome,
    setFormLojaId,
    setCurrentPage,
  } = useTamanhosPage();

  const tableActions = createTableActions(
    (rowIndex) => {
      const selectedTamanho = tamanhos[rowIndex];
      if (!selectedTamanho) return;
      openEditModal(selectedTamanho);
    },
    (rowIndex) => {
      const selectedTamanho = tamanhos[rowIndex];
      if (!selectedTamanho) return;
      handleDelete(selectedTamanho);
    }
  );

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-4 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Gerenciar Tamanhos"
          description="Aqui você pode administrar os tamanhos do sistema."
        />
        <PageActions
          onFilter={openFilterModal}
          onAdd={openCreateModal}
          addButtonText="Novo Tamanho"
          activeFiltersCount={activeFiltersCount}
        />
      </div>

      <hr />

      <div className="overflow-x-auto pb-4">
        <div className="min-w-max">
          <Table
            headers={["Tamanho", "Loja"]}
            data={tableData}
            actions={tableActions}
          />
        </div>
      </div>

      {totalPages > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
        />
      )}

      {isLoading && (
        <div className="mt-3 text-sm text-neutral-500">
          Carregando tamanhos...
        </div>
      )}

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={closeFilterModal}
        fields={filterFields}
        onFieldChange={handleFilterFieldChange}
        onSearch={handleSearch}
        onClear={handleClear}
      />

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={formState.id ? "Editar Tamanho" : "Novo Tamanho"}
      >
        {isModalOpen && (
          <TamanhosForm
            nome={formState.nome}
            lojaId={formState.lojaId}
            lojas={lojas}
            isSaving={isSaving}
            onSubmit={handleSubmit}
            onCancel={closeModal}
            onNomeChange={setFormNome}
            onLojaChange={setFormLojaId}
          />
        )}
      </Modal>
    </main>
  );
};

const Tamanhos: React.FC = () => {
  return (
    <TamanhosProvider>
      <TamanhosContent />
    </TamanhosProvider>
  );
};

export default Tamanhos;
